// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsAcquisitionTopo_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 0H6.99998L5.99998 1.99999H18L17 0ZM7.99998 12C7.99998 13.8638 9.27475 15.4299 11 15.8739V13.7324C10.4022 13.3866 9.99997 12.7402 9.99997 12 9.99997 10.8954 10.8954 9.99997 12 9.99997 12.7402 9.99997 13.3866 10.4022 13.7324 11H15.8739C15.4299 9.27475 13.8638 7.99998 12 7.99998 9.79084 7.99998 7.99998 9.79084 7.99998 12Z" class="svg-bg"/>
  <path d="M1.99999 18H11V19.9999H0V3.99999H23.9999V11H21.9999V5.99998H1.99999V18Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12H12V23.9999H24V12ZM14 14H22V15.788C20.8442 15.2972 19.4748 15.009 18.0054 15.0002C16.5353 14.9913 15.162 15.2631 14 15.7403V14ZM17.9933 17.0001C19.6183 17.0099 21.0181 17.4304 22 18.0273V19.3556C21.2805 19.1266 20.4891 19 19.6583 19C17.0462 19 14.824 20.2518 14 21.9992V17.9637C14.9877 17.3869 16.3823 16.9904 17.9933 17.0001ZM14 21.9992L22 21.9999V21.4993C21.3583 21.1956 20.558 20.9999 19.6583 20.9999C18.3923 20.9999 17.3232 21.3873 16.6156 21.918C16.5796 21.945 16.5447 21.9722 16.511 21.9995L14 21.9992Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsAcquisitionTopo is a generated icon component.
 */
let IconRmsAcquisitionTopo = IconRmsAcquisitionTopo_1 = class IconRmsAcquisitionTopo extends IconBaseElement {
    render() {
        return html `${IconRmsAcquisitionTopo_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsAcquisitionTopo.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsAcquisitionTopo = IconRmsAcquisitionTopo_1 = __decorate([
    customElement('zui-icon-rms-acquisition-topo')
], IconRmsAcquisitionTopo);
export { IconRmsAcquisitionTopo };
